import React, { FC } from "react";
import classNames from "classnames";
import { FieldStatus } from "../../Helpers/FieldStatus";
import { SvgIcon } from "../../../SvgIcon/SvgIcon";
import { Card } from "../../Card/Card";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";

interface TreatmentsCardListProps {
  treatment: TreatmentsContainerDto;
  onSelect: (treatment: TreatmentsContainerDto | ServiceContainerDto) => void;
  status?: FieldStatus;
  error?: {
    message?: string;
  };
}

export const TreatmentsCardList: FC<TreatmentsCardListProps> = (props) => {
  const {
    treatment: treatmentContainer,
    onSelect,
    status = FieldStatus.active,
    error,
  } = props;

  const headingIconName = treatmentContainer?.icon || "health";

  return (
    <div
      className={classNames("CardList", {
        "CardList--disabled": status === FieldStatus.disabled,
        "CardList--error": status === FieldStatus.error,
      })}
    >
      {treatmentContainer?.bookingName && (
        <h3 className="CardList__heading">
          <SvgIcon
            iconName={headingIconName}
            className="CardList__headingIcon"
          />
          {treatmentContainer.stepHeading || treatmentContainer.bookingName}
        </h3>
      )}
      <ul className="CardList__list">
        {treatmentContainer.items.map((treatment) => (
          <li key={treatment.containerId} className="CardList__item">
            <button
              className="CardList__button"
              onClick={() => onSelect(treatment)}
            >
              <Card
                className={"CardList__card"}
                heading={treatment.bookingName}
                description={treatment.description}
              />
            </button>
          </li>
        ))}
      </ul>
      {status == FieldStatus.error && error && error.message && (
        <span>{error.message}</span>
      )}
    </div>
  );
};
